import { Authority } from "./group-detail/authority.model";

export class Group {
    public groupId: number;
    public accountId: number;
    public description: string;
    public version: number;
    public authorities : Authority[];
    
    constructor (groupId:number,description:string){
            this.groupId=groupId;
            this.description=description;
    }
    
}